<template>
  <pt-video-manage class="pt-video-manage__withData"></pt-video-manage>
</template>

<script>
import PtVideoManage from './index'
export default {
  name: 'pt-video-manage__withData',
  components: {
    'pt-video-manage': PtVideoManage
  }
}
</script>
